import React, { useState, useEffect } from 'react'
import { Doughnut, defaults } from "react-chartjs-2";
import Chart from 'chart.js'

var originalDoughnutDraw = Chart.controllers.doughnut.prototype.draw;
Chart.helpers.extend(Chart.controllers.doughnut.prototype, {
  draw: function () {
    originalDoughnutDraw.apply(this, arguments);

    var chart = this.chart.chart;
    var ctx = chart.ctx;
    var width = chart.width;
    var height = chart.height;

    var text = chart.config.data.text;
    // console.log(chart, ctx)

    var sidePadding = 20;
    var sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);

    ctx.font = "30px " + "IRANSans";

    //Get the width of the string and also the width of the element minus 10 to give it 5px side padding
    var stringWidth = ctx.measureText(text).width;
    var elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

    // Find out how much the font can grow in width.
    var widthRatio = elementWidth / stringWidth;
    var newFontSize = Math.floor(30 * widthRatio);
    var elementHeight = chart.innerRadius * 2;

    // Pick a new font size so it will not be larger than the height of label.
    var fontSizeToUse = Math.min(newFontSize, elementHeight);

    var centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
    var centerY = (chart.chartArea.top + chart.chartArea.bottom) / 2;

    var fontSize = (height / 114).toFixed(2);
    ctx.font = fontSize + "em Verdana";
    ctx.textBaseline = "middle";

    ctx.textAlign = "center";
    ctx.font = fontSizeToUse + "px " + "IRANSans";

    var textX = Math.round((width - ctx.measureText(text).width) / 2);
    var textY = height / 2;

    ctx.fillText(text, centerX, centerY);
  }
});

const options = {
  defaultFontFamily: 'IRANSans',
  tooltips: {
    titleFontFamily: 'IRANSans',
    bodyFontFamily: 'IRANSans',
    footerFontFamily: 'IRANSans',
    yAlign: 'bottom',
    backgroundColor: '#2DCD7A',
    bodyFontColor: '#fff',
    displayColors: false,
  },
  legend: {
    display: true,
    position: "bottom",
    marginTop: 20,
    labels: {
      fontFamily: 'IRANSans',
      fontColor: '#000'
    }
  },
};

defaults.global.defaultFontFamily = 'IRANSans'

export const DoughnutChart = (props) => {

  const [data, setData] = useState(props.data);

  useEffect(() => {
    setData(props.data);
  }, [props.data])

  return (
    <div className="dashboard-box doughnut-chart-container">
      {
        props.loading ?
          <div className="loader-container">
            <div class="loader-02"></div>
          </div>
          :
          data &&
          <Doughnut
            data={
              {
                labels: props.type === 1 ? ['محصول', 'محصول درجه 2'] :
                  props.type === 2 ? ['ورق پرس شده', 'ضایعات ورق پرس شده',] :
                    [],
                datasets: [
                  {
                    data: props.type === 1 ? [
                      data.totalProduct && data.totalProduct.toFixed(0),
                      data.totalGradeTwoProduct && data.totalGradeTwoProduct.toFixed(0),
                      // data.totalTileWaste && data.totalTileWaste.toFixed(0)
                    ] :
                      props.type === 2 ? [
                        data.totalHdf && data.totalHdf.toFixed(0),
                        data.totalHdfWaste && data.totalHdfWaste.toFixed(0)
                      ] :
                        [],
                    backgroundColor: props.type === 1 ? ["#3366CC", "#10ec1f", "#DC3912"] :
                      props.type === 2 ? ["#FF9800", "#F7E402"] :
                        [],
                    // hoverBackgroundColor: ["#36A2EB", "#FF6384",],
                    fontColor: ["#fff"]
                  }
                ],
                text: ''
              }
            }
            options={options} />
      }
    </div>
  )
}

